import axios from 'axios';
import React, { useContext, useState, useEffect } from 'react';
import authenticate from '../../utils/Authenticate';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import displayError from '../../utils/ErrorHandler';

const AddItem = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    units: '',
    price: '',
    purchaseType: '',
    misc: false
  });
  const [notification, setNotification] = useState({ message: '', type: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const submitData = async (e) => {
    e.preventDefault();
    const finalObject = {
      item: {
        name: formData.name,
        unit: formData.units,
        category: formData.category,
        price: formData.price,
        purchaseType: formData.purchaseType,
        misc: formData.misc
      }
    };

    console.log("Payload being sent:", finalObject);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/items/create`,
        finalObject,
        { withCredentials: true }
      );
      setNotification({ message: response.data.message || 'Item created successfully!', type: 'success' });
      setFormData({
        name: '',
        category: '',
        units: '',
        price: '',
        purchaseType: '',
        misc: false
      });
      window.scrollTo(0, 0);
    } catch (err) {
      const errorMessage = displayError(err,navigate,setUser);
      if(errorMessage){
        setNotification({ message: errorMessage, type: 'error' });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, setUser, navigate]);

  return (
    <div className="wrapper">
      <div className="w-full">
        <h2 className="text-base font-bold bg-lime-800 text-white p-3 py-4 text-center">
          Create Item
        </h2>
        {notification.message && (
          <div
            className={`p-2 mb-4 ${
              notification.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {notification.message}
          </div>
        )}
      </div>

      <div className="p-4 max-w-2xl mx-auto">
        <form className="space-y-6" onSubmit={submitData}>
          {/* Item Name */}
          
          <div>
            <div className="mt-2">
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Item Name"
                autoComplete="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div className="flex items-center space-x-2 mt-2">
            <input
              id="misc"
              name="misc"
              type="checkbox"
              checked={formData.misc}
              onChange={(e) =>{
                setFormData({ ...formData, misc: e.target.checked })
                console.log('misc is now', e.target.checked);
              }
              }
              className="h-5 w-10 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
            />
            <label htmlFor="misc" className="text-sm text-gray-700">
              Is Item Miscellaneous? &nbsp;
              
              <span className="text-xs text-blue-400">
                 {  `<Misceallenous Like Cold Storage, Shipping , Labour king of items to be add as charges>`}
                </span>
            </label>
          </div>

          {/* Category */}
          <div>
            <div className="mt-2">
              <input
                id="category"
                name="category"
                type="text"
                placeholder="Item Category (Ex- Fruits)"
                autoComplete="current-category"
                value={formData.category}
                onChange={handleChange}
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          {/* Units */}
          <select
            value={formData.units}
            onChange={handleChange}
            name="units"
            className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          >
            <option value="" disabled selected>
              Select Unit
            </option>
            <option value="kg">kg</option>
            <option value="nos">nos</option>
            <option value="litre">litre</option>
            <option value="bottles">bottles</option>
          </select>

          {/* Purchase Type */}
          <select
            value={formData.purchaseType}
            onChange={handleChange}
            name="purchaseType"
            className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          >
            <option value="" disabled selected>
              Select Purchase Type
            </option>
            <option value="central">Central</option>
            <option value="zone">Within Zone</option>
          </select>

          {/* Price */}
          <div>
            <div className="mt-2">
              <input
                id="price"
                name="price"
                type="number"
                placeholder="Item Price"
                autoComplete="current-price"
                value={formData.price}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              CREATE ITEM
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddItem;